import { render, staticRenderFns } from "./JobAccountFormStepProjectContacts.vue?vue&type=template&id=08b8777e"
import script from "./JobAccountFormStepProjectContacts.vue?vue&type=script&lang=js"
export * from "./JobAccountFormStepProjectContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports